import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { AlertComponent } from '../../../../shared/components/alert/alert.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { SupportModeStore } from '../../core/stores/SupportModeStore';

@Component({
  selector: 'app-support-mode-banner',
  standalone: true,
  imports: [
    AlertComponent,
    TranslatePipe
  ],
  templateUrl: './support-mode-banner.component.html',
  styleUrl: './support-mode-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportModeBannerComponent extends BaseComponent {

  public readonly supportModeStore = inject(SupportModeStore);
}
